module.exports = __webpack_public_path__ + "img/avatar3.5f2bf034.png";